import { Button } from 'react-bootstrap'
import cn from 'classnames'
import Loading from '../../../../templates/Loading'

export default function JournalEntryButtons({
  handleClick,
  isButtonLoading,
  checkContent,
  isDeleteLoading,
  pastJournalID,
  handleDelete,
  showDeleteButton = false,
  children
}) {
  return (
    <>
      <Button
        size='lg'
        variant='primary'
        className={cn('text-white', showDeleteButton ? 'w-75' : 'w-100')}
        onClick={handleClick}
        disabled={checkContent || isButtonLoading}
      >
        {children}
      </Button>

      {showDeleteButton && (
        <Button variant='light' onClick={handleDelete} className='w-25'>
          {isDeleteLoading ? (
            <Loading
              isLoaded={true}
              hasContainer={false}
              loadingClass={'align-center'}
            />
          ) : (
            <i
              className={cn('icon bi-trash fs-4 cursor-pointer', {
                disabled: !pastJournalID
              })}
            ></i>
          )}
        </Button>
      )}
    </>
  )
}
